/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CountryMetric } from '../models/CountryMetric';
import type { UserBank } from '../models/UserBank';
import { request as __request } from '../core/request';

export class BanksService {

    /**
     * @returns CountryMetric
     * @throws ApiError
     */
    public static async banksGetCountries(): Promise<Array<CountryMetric>> {
        const result = await __request({
            method: 'GET',
            path: `/api/banks/countries`,
        });
        return result.body;
    }

    /**
     * @returns UserBank
     * @throws ApiError
     */
    public static async banksGetList({
        countryCode
    }: {
        countryCode?: string | null
    }): Promise<Array<UserBank>> {
        const result = await __request({
            method: 'GET',
            path: `/api/banks/list`,
            query: {
                'countryCode': countryCode
            },
        });
        return result.body;
    }

    public static async banksGetSelected({
        countryCode,
        email,
    }: {
        countryCode?: string | null,
        email: string,
    }): Promise<Array<UserBank>> {
        const result = await __request({
            method: 'GET',
            path: `/api/banks/selected`,
            query: {
                'countryCode': countryCode,
                'email': email
            },
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async banksSelectBank({
        bank,
        email
    }: {
        bank: UserBank,
        email: string,
    }): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/api/banks/select`,
            query: {
                'email': email
            },
            body: bank,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async banksRemoveSelection({
        unselectedBank,
        email
    }: {
        unselectedBank: UserBank,
        email: string,
    }): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/banks/select`,
            query: {
                'email': email
            },
            body: unselectedBank,
        });
        return result.body;
    }
    

    /**
     * @returns any
     * @throws ApiError
     */
    public static async banksEditBank({
        editedBank,
    }: {
        editedBank: UserBank,
    }): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/api/banks/edit`,
            body: editedBank,
        });
        return result.body;
    }

}